<template>
  <ul id="faq">
    <FaqItem
      v-for="(item, index) in $config.common.faq.items"
      :key="index"
      :question="item.question"
      :answer="item.answer"
      :opened="openedIndex === index"
      class="faq-item"
      @click.native="toggle(index)"
    />
  </ul>
</template>
<script>
import FaqItem from './FaqItem.vue';

export default {
  name: 'FAQ',
  components: {
    FaqItem,
  },
  data() {
    return {
      openedIndex: -1,
    };
  },
  computed: {
  },
  methods: {
    toggle(index) {
      this.openedIndex = this.openedIndex === index ? -1 : index;
    },
  },
};
</script>
<style lang="stylus" scoped>
ul {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
}
</style>
